import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BuildingSectionItemDto, BuildingService } from '@artemis-software/wr-api';
import { Tracked } from '@/utils/signals/tracked';
import { loader } from '@/utils/signals/loader';
import { asyncComputed } from '@/utils/signals/asyncComputed';

@Component({
  standalone: false,
  selector: 'wr-building-section-popover',
  templateUrl: './building-section-popover.component.html',
  styleUrls: ['./building-section-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuildingSectionPopoverComponent {
  readonly router = inject(Router);
  readonly buildingService = inject(BuildingService);

  @Input()
  @Tracked()
  buildingSection?: BuildingSectionItemDto;

  @Input()
  @Tracked()
  disableLink = false;

  loading = loader();

  building = asyncComputed(() => {
    const buildingId = this.buildingSection?.buildingId;
    if (buildingId) {
      return this.buildingService.findById(buildingId);
    }
    return undefined;
  }, undefined, this.loading);

  navigateToDetail() {
    this.router.navigate(['building', this.buildingSection?.buildingId]);

  }
}
